/**
 * Clinical-category Sentry breadcrumbs. Every mutation or reveal with
 * clinical impact (submit report, approve report, raise red flag, reveal PHI,
 * join call) should emit a breadcrumb through this helper BEFORE the API
 * call — per foundations §13.
 *
 * Never log PHI content. IDs only. The `data` payload is flat and bounded;
 * callers are responsible for not passing sensitive values.
 */

import * as Sentry from '@sentry/react';

type BreadcrumbMessage =
  | 'phi:reveal'
  | 'phi:hide'
  | 'note:create'
  | 'note:update'
  | 'note:submit'
  | 'case-report:create'
  | 'case-report:update'
  | 'case-report:submit'
  | 'case-report:approve'
  | 'case-report:reject'
  | 'case-report:escalate'
  | 'red-flag:raise'
  | 'session:join'
  | 'session:mark-complete'
  | 'call:recording-start'
  | 'call:recording-stop'
  | 'call:end'
  | 'call:participant-mute'
  | 'call:participant-kick'
  | 'exercise:assign'
  | 'exercise:review';

export function clinicalBreadcrumb(
  message: BreadcrumbMessage,
  data?: Record<string, string | number | boolean>,
): void {
  Sentry.addBreadcrumb({
    category: 'clinical',
    message,
    level: 'info',
    data,
  });
}
